import { render, staticRenderFns } from "./load.vue?vue&type=template&id=5f9fb5c2&scoped=true"
import script from "./load.vue?vue&type=script&lang=js"
export * from "./load.vue?vue&type=script&lang=js"
import style0 from "./load.vue?vue&type=style&index=0&id=5f9fb5c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9fb5c2",
  null
  
)

export default component.exports